import { getThemeColor } from 'style-utils/theme/utils/getThemeColor';
import styled from 'styled-components';

export const LabelInput = styled.label`
  font-weight: 400;
  line-height: 1.8;
  font-size: 1.4rem;
  color: ${getThemeColor('fieldColor')};
  position: absolute;
  pointer-events: none;
  background-color: inherit;
  top: 0.8rem;
  left: 1.3rem;
  transition: 0.2s ease all;
`;
